import React, { useState, useEffect } from "react";

// ============================================================================
// 1. LISTE DE TOUS LES DOCUMENTS
// ============================================================================
const ALL_DOCUMENTS_PENSION = {
  // --- Certificat de naissance DU CLIENT ---
  CLIENT_BIRTH_CERT: {
    id: "CLIENT_BIRTH_CERT",
    category: "Documents administratifs",
    label: "Certificat de naissance du client (vous)",
    description:
      "Parfois requis pour vérifier votre identité ou votre statut. En cas d'absence, discutez d'une déclaration sous serment avec un avocat. S'il est en langue étrangère, une traduction certifiée est obligatoire.",
  },
  TRADUCTION_CERTIFIEE_CLIENT: {
    id: "TRADUCTION_CERTIFIEE_CLIENT",
    category: "Documents administratifs",
    label: "Traduction certifiée du certificat de naissance (vous)",
    description:
      "Le certificat de votre naissance est dans une autre langue que français/anglais. Fournissez une traduction certifiée faite au Québec.",
  },

  // --- Certificats de naissance & traductions (enfants) ---
  BIRTH_CERT_CHILD: {
    id: "BIRTH_CERT_CHILD",
    category: "Documents administratifs",
    label: "Certificat de naissance de chaque enfant mineur",
    description:
      "Pour prouver la filiation et l'identité des enfants. Si introuvable, consultez un avocat pour une déclaration sous serment. En cas de langue étrangère, une traduction certifiée est requise.",
  },
  TRADUCTION_CERTIFIEE_ENFANT: {
    id: "TRADUCTION_CERTIFIEE_ENFANT",
    category: "Documents administratifs",
    label: "Traduction certifiée du certificat de naissance (enfant)",
    description:
      "Vous avez indiqué que le certificat de naissance de l'enfant est dans une autre langue que français/anglais. Fournissez une traduction certifiée faite au Québec.",
  },

  // --- Conjoint de fait : Certificat de naissance & traduction ---
  CERTIFICAT_NAISSANCE_CONJOINT: {
    id: "CERTIFICAT_NAISSANCE_CONJOINT",
    category: "Documents administratifs",
    label: "Certificat de naissance de l'autre conjoint de fait",
    description:
      "Parfois requis pour vérifier l'identité de l'autre conjoint. En cas d'absence, discutez d'une déclaration sous serment avec un avocat. S'il est en langue étrangère, une traduction certifiée est obligatoire.",
  },
  TRADUCTION_CERTIFIEE_CONJOINT: {
    id: "TRADUCTION_CERTIFIEE_CONJOINT",
    category: "Documents administratifs",
    label: "Traduction certifiée du certificat de naissance (conjoint)",
    description:
      "Le certificat de naissance du conjoint est dans une autre langue que français/anglais. Fournissez une traduction certifiée faite au Québec.",
  },

  // --- Documents administratifs divers ---
  PROOF_RESIDENCE: {
    id: "PROOF_RESIDENCE",
    category: "Documents administratifs",
    label: "Preuve de résidence (bail, facture, etc.)",
    description: "Pour démontrer la résidence habituelle au Québec (compétence du tribunal).",
  },

  // == Documents financiers ==
  DECLARATION_IMPOTS_FEDERALE: {
    id: "DECLARATION_IMPOTS_FEDERALE",
    category: "Documents administratifs",
    label: "Déclaration d'impôts fédérale la plus récente",
    description:
      "Incluez l'avis de cotisation si possible. Permet d'établir vos revenus pour le calcul de la pension.",
  },
  DECLARATION_IMPOTS_PROVINCIALE: {
    id: "DECLARATION_IMPOTS_PROVINCIALE",
    category: "Documents administratifs",
    label: "Déclaration d'impôts provinciale la plus récente",
    description:
      "Incluez l'avis de cotisation si possible. Permet d'établir vos revenus pour le calcul de la pension.",
  },
  AVIS_COTISATION: {
    id: "AVIS_COTISATION",
    category: "Documents administratifs",
    label: "Avis de cotisation (fédéral et provincial)",
    description:
      "Émis par l'Agence du revenu du Canada et Revenu Québec, confirmant votre impôt final.",
  },
  RELEVES_PAIE: {
    id: "RELEVES_PAIE",
    category: "Documents administratifs",
    label: "Relevés de paie récents",
    description:
      "Démontre votre revenu courant. Habituellement, on fournit les talons de paie des derniers mois.",
  },
  RELEVE_T4_ET_ETATS_FINANCIERS: {
    id: "RELEVE_T4_ET_ETATS_FINANCIERS",
    category: "Documents administratifs",
    label: "Relevé T4 (ou T2125) et états financiers (si travail autonome)",
    description:
      "Pour les travailleurs autonomes ou propriétaires de compagnie, incluez les déclarations d'entreprise.",
  },

  // --- Jugements ou ententes antérieurs ---
  ANY_PREVIOUS_JUDGMENT: {
    id: "ANY_PREVIOUS_JUDGMENT",
    category: "Documents juridiques",
    label: "Tout jugement ou entente antérieurs (pension)",
    description:
      "Toute décision de justice ou entente homologuée existante doit être jointe pour éviter les contradictions.",
  },

  // --- Procédure : Demande, mesures, etc. ---
  DEMANDE_INTRODUCTIVE_INSTANCE: {
    id: "DEMANDE_INTRODUCTIVE_INSTANCE",
    category: "Documents juridiques",
    label: "Demande introductive d'instance (pension)",
    description:
      "Document officiel pour initier la procédure devant la Cour en matière de pension alimentaire.",
  },
  FORMULAIRE_REPONSE: {
    id: "FORMULAIRE_REPONSE",
    category: "Documents juridiques",
    label: "Formulaire de réponse à la demande",
    description:
      "Si vous avez reçu la demande introductive, vous devez remplir ce formulaire pour répondre au tribunal.",
  },
  DEMANDE_MESURES_PROVISOIRES: {
    id: "DEMANDE_MESURES_PROVISOIRES",
    category: "Documents juridiques",
    label: "Demande de mesures provisoires (pension)",
    description:
      "Permet d'obtenir une décision temporaire sur la pension alimentaire en attendant la décision finale.",
  },
  ORDONNANCE_SAUVEGARDE: {
    id: "ORDONNANCE_SAUVEGARDE",
    category: "Documents juridiques",
    label: "Ordonnance de sauvegarde (urgence/violence)",
    description:
      "En cas d'urgence (violence, danger), vous pouvez demander une ordonnance de sauvegarde pour vous protéger.",
  },

  // --- Pension alimentaire (Annexe I) ---
  FORMULAIRE_ANNEXE_I: {
    id: "FORMULAIRE_ANNEXE_I",
    category: "Documents juridiques",
    label: "Formulaire Annexe I (calcul de la pension alimentaire)",
    description:
      "Chiffrier obligatoire pour déterminer le montant de la pension selon les barèmes officiels.",
  },

  // --- Déclaration 444 ---
  DECLARATION_ART_444: {
    id: "DECLARATION_ART_444",
    category: "Documents juridiques",
    label: "Déclaration 444 C.p.c.",
    description:
      "Requise lorsqu'une obligation alimentaire est demandée. Indique vos revenus et vos dépenses.",
  },

  // --- Liste de pièces ---
  LISTE_PIECES: {
    id: "LISTE_PIECES",
    category: "Documents juridiques",
    label: "Liste de pièces",
    description:
      "Tableau ou liste énumérant toutes les pièces justificatives déposées avec votre demande ou requête.",
  },

  // --- Formulaire SAH (amiable) ---
  FORMULAIRE_SAH: {
    id: "FORMULAIRE_SAH",
    category: "Documents juridiques",
    label: "Formulaire SAH (procédure amiable)",
    description:
      "Utilisé pour demander l'homologation d'une entente de pension alimentaire sans opposition. Permet de soumettre au tribunal une convention conjointe.",
  },
};

// ============================================================================
// 2. DÉFINITION DES ÉTAPES DU QUESTIONNAIRE
// ============================================================================
const stepsData = [
  // -----------------------------------------------------------------------
  // Étape 1 : Situation de base
  // -----------------------------------------------------------------------
  {
    id: "step1",
    title: "Situation de base",
    shortContent:
      "Déterminez votre situation personnelle et celle de vos enfants, le cas échéant.",
    detailedContent: `
      <h4 class="font-bold">1) Votre situation</h4>
      <p>Déterminez si vous habitez au Québec, s'il existe déjà un jugement/entente sur la pension, 
         et si vous avez votre propre certificat de naissance.</p>
      <br />
      <h4 class="font-bold">2) Situation des enfants</h4>
      <p>Indiquez le nombre d'enfants mineurs et si vous possédez leurs certificats de naissance. 
         Même si vous ne les avez pas, essayez de préciser la langue du document.</p>
      <br />
      <h4 class="font-bold">3) L'autre conjoint de fait (s'il y a lieu)</h4>
      <p>Précisez si vous avez le certificat de naissance du conjoint (éventuellement requis) et sa langue.</p>
    `,
    questions: [
      // 1) Votre situation
      {
        id: "q_residence",
        label: "Résidez-vous habituellement au Québec ?",
        options: [
          { value: "oui", label: "Oui" },
          { value: "non", label: "Non" },
        ],
        help: "Cela peut influer sur la compétence du tribunal.",
      },
      {
        id: "q_previous_judgment",
        label: "Existe-t-il déjà un jugement ou une entente concernant la pension alimentaire ?",
        options: [
          { value: "oui", label: "Oui, un jugement/entente en vigueur" },
          { value: "non", label: "Non, rien d'officiel" },
        ],
      },
      {
        id: "q_client_birthcertificate",
        label: "Possédez-vous votre propre certificat de naissance ?",
        options: [
          { value: "oui", label: "Oui, je l'ai" },
          { value: "non", label: "Non, introuvable" },
        ],
      },
      {
        id: "q_client_birthcertificate_language",
        label: "Dans quelle langue est votre certificat de naissance ?",
        options: [
          { value: "fr_en", label: "Français ou anglais" },
          { value: "autre", label: "Autre langue (traduction requise)" },
        ],
        showIf: (allAns) => allAns["step1"]?.q_client_birthcertificate === "oui",
      },

      // 2) Situation des enfants
      {
        id: "q_children",
        label: "Avez-vous des enfants mineurs pour lesquels une pension est demandée ou à réviser ?",
        options: [
          { value: "oui", label: "Oui (un ou plusieurs enfants mineurs)" },
          { value: "non", label: "Non (aucun enfant mineur concerné)" },
        ],
      },
      {
        id: "q_child_birthcertificate",
        label: "Possédez-vous le(s) certificat(s) de naissance de l'enfant (ou des enfants) ?",
        options: [
          { value: "oui", label: "Oui" },
          { value: "non", label: "Non, introuvable" },
        ],
        showIf: (allAns) => allAns["step1"]?.q_children === "oui",
      },
      {
        id: "q_child_birthcertificate_language_yes",
        label: "Dans quelle langue est (sont) le(s) certificat(s) de naissance des enfants ?",
        options: [
          { value: "fr_en", label: "Français ou anglais" },
          { value: "autre", label: "Autre langue (traduction requise)" },
        ],
        // S'affiche seulement si on possède le document
        showIf: (allAns) =>
          allAns["step1"]?.q_children === "oui" &&
          allAns["step1"]?.q_child_birthcertificate === "oui",
      },
      {
        id: "q_child_birthcertificate_language_no",
        label: "Si vous ne l'avez pas : savez-vous dans quelle langue est établi ce certificat ?",
        options: [
          { value: "fr_en", label: "Français ou anglais" },
          { value: "autre", label: "Autre langue (traduction requise)" },
          { value: "inconnu", label: "Je ne sais pas" },
        ],
        // S'affiche seulement si on n'a pas le document
        showIf: (allAns) =>
          allAns["step1"]?.q_children === "oui" &&
          allAns["step1"]?.q_child_birthcertificate === "non",
      },

      // 3) L'autre conjoint
      {
        id: "q_conjoint_birthcertificate",
        label: "Possédez-vous le certificat de naissance de l'autre conjoint de fait ?",
        options: [
          { value: "oui", label: "Oui, je l'ai" },
          { value: "non", label: "Non, introuvable" },
        ],
      },
      {
        id: "q_conjoint_birthcertificate_language",
        label: "Dans quelle langue est ce certificat de naissance ?",
        options: [
          { value: "fr_en", label: "Français ou anglais" },
          { value: "autre", label: "Autre langue (traduction requise)" },
        ],
        showIf: (allAns) => allAns["step1"]?.q_conjoint_birthcertificate === "oui",
      },
    ],
  },

  // -----------------------------------------------------------------------
  // Étape 2 : Type de procédure (Amiable ou contestée)
  // -----------------------------------------------------------------------
  {
    id: "step2",
    title: "Type de procédure",
    shortContent: "Choisissez si votre démarche est amiable ou contestée.",
    detailedContent: `
      <p>Si les deux parties s'entendent pour régler la pension alimentaire sans opposition majeure, 
         vous pouvez entamer une procédure amiable. Dans le cas contraire, vous devrez passer par une procédure contestée 
         (demande introductive, réponse, etc.).</p>
    `,
    questions: [
      {
        id: "q_procedure_type",
        label: "Votre procédure est-elle amiable ou contestée ?",
        options: [
          { value: "amiable", label: "Amiable (règlement sans opposition)" },
          { value: "contestee", label: "Contestée (l'autre partie s'oppose)" },
        ],
      },
    ],
  },

  // -----------------------------------------------------------------------
  // Étape 3 : Procédure contestée : démarrage et mesures
  //   (n'apparaît que si la personne choisit "contestée" à l'étape 2)
// -----------------------------------------------------------------------
  {
    id: "step3",
    title: "Procédure contestée : démarrage et mesures",
    shortContent: "Demande introductive, mesures provisoires, ordonnance de sauvegarde, etc.",
    detailedContent: `
      Dans cette étape, vous indiquez si vous allez initier une demande officielle (pension), 
      ou si vous avez reçu la demande et devez y répondre. 
      Vous pouvez aussi préciser si vous avez besoin de mesures provisoires ou d'une ordonnance de sauvegarde en urgence.
    `,
    questions: [
      {
        id: "q_demande_intro",
        label: "Demande introductive d'instance : êtes-vous le requérant ou avez-vous reçu la demande ?",
        options: [
          { value: "oui", label: "Oui, je suis le requérant (je dépose la demande)" },
          { value: "non", label: "Non, j'ai reçu la demande et je dois y répondre" },
        ],
        help: `Si vous avez reçu la demande, vous devez remplir un formulaire de réponse dans les délais.`,
      },
      {
        id: "q_mesures_provisoires",
        label: "Souhaitez-vous demander des mesures provisoires (pension provisoire, etc.) ?",
        options: [
          { value: "oui", label: "Oui" },
          { value: "non", label: "Non" },
        ],
      },
      {
        id: "q_sauvegarde",
        label: "Avez-vous besoin d'une ordonnance de sauvegarde (urgence/violence) ?",
        options: [
          { value: "oui", label: "Oui (situation urgente)" },
          { value: "non", label: "Non" },
        ],
      },
    ],
  },

  // -----------------------------------------------------------------------
  // Étape 4 : Pension alimentaire (enfants)
  // -----------------------------------------------------------------------
  {
    id: "step4",
    title: "Pension alimentaire pour enfants",
    shortContent: "Indiquez si vous réclamez ou modifiez une pension alimentaire.",
    detailedContent: `
      Les deux parents doivent contribuer aux besoins de leurs enfants. 
      Si vous demandez une pension alimentaire ou souhaitez la modifier, vous devez remplir l'Annexe I. 
      Vous devrez également fournir vos preuves de revenus (étape suivante).
    `,
    questions: [
      {
        id: "q_child_pension",
        label: "Souhaitez-vous demander ou modifier la pension alimentaire pour enfant(s) ?",
        options: [
          { value: "oui", label: "Oui" },
          { value: "non", label: "Non" },
        ],
        help: "L'Annexe I est obligatoire si vous réclamez une pension alimentaire pour enfant(s).",
      },
      {
        id: "q_child_pension_calc",
        label: "Avez-vous déjà rempli l'Annexe I (calcul de la pension) ?",
        options: [
          { value: "oui", label: "Oui, déjà fait" },
          { value: "non", label: "Non, je dois encore la préparer" },
        ],
        showIf: (allAns) => allAns["step4"]?.q_child_pension === "oui",
      },
    ],
  },

  // -----------------------------------------------------------------------
  // Étape 5 : Informations financières et déclaration
  // -----------------------------------------------------------------------
  {
    id: "step5",
    title: "Informations financières & déclarations d'impôts",
    shortContent: "Justifiez vos revenus, déterminez si la Déclaration 444 est nécessaire.",
    detailedContent: `
      Pour fixer ou modifier une pension, le tribunal exige des pièces prouvant vos revenus 
      (déclarations d'impôts fédérale/provinciale, avis de cotisation, relevés de paie, etc.). 
      La Déclaration (art. 444 C.p.c.) est requise dès qu'une obligation alimentaire est demandée.
    `,
    questions: [
      {
        id: "q_declaration_impots_federale",
        label: "Avez-vous votre dernière déclaration d'impôts fédérale + avis de cotisation ?",
        options: [
          { value: "oui", label: "Oui" },
          { value: "non", label: "Non, je dois l'obtenir" },
        ],
      },
      {
        id: "q_declaration_impots_provinciale",
        label: "Avez-vous votre dernière déclaration d'impôts provinciale + avis de cotisation ?",
        options: [
          { value: "oui", label: "Oui" },
          { value: "non", label: "Non, je dois l'obtenir" },
        ],
      },
      {
        id: "q_releves_paie",
        label: "Avez-vous vos relevés de paie récents ?",
        options: [
          { value: "oui", label: "Oui" },
          { value: "non", label: "Non, je dois les demander à mon employeur" },
        ],
      },
      {
        id: "q_travail_autonome",
        label: "Êtes-vous travailleur autonome ou propriétaire d'une compagnie ?",
        options: [
          { value: "oui", label: "Oui" },
          { value: "non", label: "Non" },
        ],
      },
      {
        id: "q_declaration_444",
        label: "Prévoyez-vous remplir la Déclaration (art. 444 C.p.c.) ?",
        options: [
          { value: "oui", label: "Oui" },
          { value: "non", label: "Non" },
        ],
        help: "Obligatoire si vous demandez une pension alimentaire ou si le tribunal l'exige.",
      },
    ],
  },
];

// ============================================================================
// 3. COMPOSANT PRINCIPAL : PensionChecklist
// ============================================================================
export default function PensionChecklist() {
  // -- États
  const [completedSteps, setCompletedSteps] = useState([]);
  const [openStep, setOpenStep] = useState(null);
  const [answers, setAnswers] = useState({});
  const [checklistDocuments, setChecklistDocuments] = useState([]);

  // =========================================================================
  // 4. useEffect : GÉNÉRATION DYNAMIQUE DE LA CHECKLIST
  // =========================================================================
  useEffect(() => {
    const neededDocs = [];

    // ----- Raccourci pour aller chercher les réponses -----
    const st1 = answers["step1"] || {};
    const st2 = answers["step2"] || {};
    const st3 = answers["step3"] || {};
    const st4 = answers["step4"] || {};
    const st5 = answers["step5"] || {};

    // ==================== Étape 1 : Situation de base ====================
    if (completedSteps.includes("step1")) {
      // Jugement antérieur ?
      if (st1.q_previous_judgment === "oui") {
        neededDocs.push(ALL_DOCUMENTS_PENSION.ANY_PREVIOUS_JUDGMENT);
      }
      // Preuve de résidence
      neededDocs.push(ALL_DOCUMENTS_PENSION.PROOF_RESIDENCE);

      // Certificat de naissance du CLIENT
      if (st1.q_client_birthcertificate === "oui") {
        neededDocs.push(ALL_DOCUMENTS_PENSION.CLIENT_BIRTH_CERT);
        if (st1.q_client_birthcertificate_language === "autre") {
          neededDocs.push(ALL_DOCUMENTS_PENSION.TRADUCTION_CERTIFIEE_CLIENT);
        }
      } else {
        neededDocs.push(ALL_DOCUMENTS_PENSION.CLIENT_BIRTH_CERT);
      }

      // Enfants ?
      if (st1.q_children === "oui") {
        if (st1.q_child_birthcertificate === "oui") {
          neededDocs.push(ALL_DOCUMENTS_PENSION.BIRTH_CERT_CHILD);
          if (st1.q_child_birthcertificate_language_yes === "autre") {
            neededDocs.push(ALL_DOCUMENTS_PENSION.TRADUCTION_CERTIFIEE_ENFANT);
          }
        } else {
          neededDocs.push(ALL_DOCUMENTS_PENSION.BIRTH_CERT_CHILD);
          if (st1.q_child_birthcertificate_language_no === "autre") {
            neededDocs.push(ALL_DOCUMENTS_PENSION.TRADUCTION_CERTIFIEE_ENFANT);
          }
        }
      }

      // Conjoint : certificat
      if (st1.q_conjoint_birthcertificate === "oui") {
        neededDocs.push(ALL_DOCUMENTS_PENSION.CERTIFICAT_NAISSANCE_CONJOINT);
        if (st1.q_conjoint_birthcertificate_language === "autre") {
          neededDocs.push(ALL_DOCUMENTS_PENSION.TRADUCTION_CERTIFIEE_CONJOINT);
        }
      } else {
        neededDocs.push(ALL_DOCUMENTS_PENSION.CERTIFICAT_NAISSANCE_CONJOINT);
      }
    }

    // ==================== Étape 2 : Type de procédure ====================
    if (completedSteps.includes("step2")) {
      // Si amiable, on ajoute le Formulaire SAH
      if (st2.q_procedure_type === "amiable") {
        neededDocs.push(ALL_DOCUMENTS_PENSION.FORMULAIRE_SAH);
      }
    }

    // ==================== Étape 3 : Procédure (contestée) ================
    if (st2.q_procedure_type === "contestee" && completedSteps.includes("step3")) {
      // Demande introductive ou réponse ?
      if (st3.q_demande_intro === "oui") {
        neededDocs.push(ALL_DOCUMENTS_PENSION.DEMANDE_INTRODUCTIVE_INSTANCE);
        neededDocs.push(ALL_DOCUMENTS_PENSION.LISTE_PIECES);
      } else if (st3.q_demande_intro === "non") {
        neededDocs.push(ALL_DOCUMENTS_PENSION.FORMULAIRE_REPONSE);
      }

      // Mesures provisoires ?
      if (st3.q_mesures_provisoires === "oui") {
        neededDocs.push(ALL_DOCUMENTS_PENSION.DEMANDE_MESURES_PROVISOIRES);
      }
      // Ordonnance de sauvegarde ?
      if (st3.q_sauvegarde === "oui") {
        neededDocs.push(ALL_DOCUMENTS_PENSION.ORDONNANCE_SAUVEGARDE);
      }
    }

    // ==================== Étape 4 : Pension alimentaire ==================
    if (completedSteps.includes("step4")) {
      if (st4.q_child_pension === "oui") {
        neededDocs.push(ALL_DOCUMENTS_PENSION.FORMULAIRE_ANNEXE_I);
        // On ajoute d'office les documents financiers
        neededDocs.push(ALL_DOCUMENTS_PENSION.DECLARATION_IMPOTS_FEDERALE);
        neededDocs.push(ALL_DOCUMENTS_PENSION.DECLARATION_IMPOTS_PROVINCIALE);
        neededDocs.push(ALL_DOCUMENTS_PENSION.AVIS_COTISATION);
        neededDocs.push(ALL_DOCUMENTS_PENSION.RELEVES_PAIE);
      }
    }

    // ==================== Étape 5 : Infos financières ====================
    if (completedSteps.includes("step5")) {
      if (st5.q_declaration_impots_federale) {
        neededDocs.push(ALL_DOCUMENTS_PENSION.DECLARATION_IMPOTS_FEDERALE);
        neededDocs.push(ALL_DOCUMENTS_PENSION.AVIS_COTISATION);
      }
      if (st5.q_declaration_impots_provinciale) {
        neededDocs.push(ALL_DOCUMENTS_PENSION.DECLARATION_IMPOTS_PROVINCIALE);
        neededDocs.push(ALL_DOCUMENTS_PENSION.AVIS_COTISATION);
      }
      if (st5.q_releves_paie) {
        neededDocs.push(ALL_DOCUMENTS_PENSION.RELEVES_PAIE);
      }
      if (st5.q_travail_autonome === "oui") {
        neededDocs.push(ALL_DOCUMENTS_PENSION.RELEVE_T4_ET_ETATS_FINANCIERS);
      }
      if (st5.q_declaration_444 === "oui") {
        neededDocs.push(ALL_DOCUMENTS_PENSION.DECLARATION_ART_444);
      }
    }

    // -- Filtrer les doublons
    const uniqueDocs = Array.from(new Set(neededDocs));
    setChecklistDocuments(uniqueDocs);
  }, [answers, completedSteps]);

  // =========================================================================
  // 5. GESTION DES ÉTAPES ET DES RÉPONSES
  // =========================================================================

  const handleAnswerChange = (stepId, questionId, value) => {
    setAnswers((prev) => ({
      ...prev,
      [stepId]: { ...prev[stepId], [questionId]: value },
    }));
  };

  const areAllQuestionsAnswered = (step) => {
    const stepAns = answers[step.id] || {};
    if (!step.questions || step.questions.length === 0) return true;

    return step.questions.every((q) => {
      // Si la question a une condition showIf, et que ce n'est pas rempli,
      // on l'ignore si la condition n'est pas remplie.
      if (q.showIf && !q.showIf(answers)) return true;

      const val = stepAns[q.id];
      return val && val.trim?.() !== "";
    });
  };

  const confirmStepCompletion = (step) => {
    return window.confirm(`Confirmez-vous avoir terminé l'étape "${step.title}" ?`);
  };

  // Cette fonction détermine quelles étapes doivent être visibles
  // (ex. on n'affiche la Procédure contestée qu'en cas de procédure contestée).
  const getVisibleSteps = () => {
    // On part de la liste complète
    let visibleSteps = [...stepsData];

    // Si la procédure choisie n'est pas "contestee", on cache step3
    const procedureType = answers["step2"]?.q_procedure_type;
    if (procedureType !== "contestee") {
      visibleSteps = visibleSteps.filter((s) => s.id !== "step3");
    }

    return visibleSteps;
  };

  const markStepAsDone = (step) => {
    // Vérifier que toutes les questions requises sont répondues
    if (!areAllQuestionsAnswered(step)) {
      alert("Veuillez répondre à toutes les questions requises avant de terminer cette étape.");
      return;
    }

    // Vérifier que les étapes précédentes sont complétées
    const visible = getVisibleSteps();
    const currentIndex = visible.findIndex((s) => s.id === step.id);
    for (let i = 0; i < currentIndex; i++) {
      const prevStep = visible[i];
      if (!completedSteps.includes(prevStep.id)) {
        alert(`Veuillez d'abord compléter l'étape "${prevStep.title}".`);
        return;
      }
    }

    // Confirmation
    if (!confirmStepCompletion(step)) return;

    // On marque l'étape comme terminée
    if (!completedSteps.includes(step.id)) {
      setCompletedSteps((prev) => [...prev, step.id]);
    }
    setOpenStep(null);
  };

  const resetAll = () => {
    if (!window.confirm("Voulez-vous vraiment réinitialiser le questionnaire ?")) return;
    setCompletedSteps([]);
    setOpenStep(null);
    setAnswers({});
    setChecklistDocuments([]);
  };

  const progressPercent = Math.round((completedSteps.length / stepsData.length) * 100);
  const completedStepsCount = completedSteps.length;
  const totalSteps = stepsData.length;

  // =========================================================================
  // 6. RENDU DU COMPOSANT
  // =========================================================================
  const visibleSteps = getVisibleSteps();

  return (
    <div className="min-h-screen bg-gray-100">
      <main className="max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="px-6 py-8 mt-4 bg-blue-50 rounded-xl border border-blue-100 shadow-sm mb-8">
          <h1 className="text-2xl font-bold text-blue-700 mb-3 text-center">
            <span className="inline-block h-1 bg-warning w-8 mr-2 rounded-full align-middle"></span>
            Checklist interactive de pension alimentaire
            <span className="inline-block h-1 bg-warning w-8 ml-2 rounded-full align-middle"></span>
          </h1>
          <p className="text-center text-blue-600 max-w-3xl mx-auto">
            Cette checklist interactive vous permet d'identifier tous les documents nécessaires 
            pour votre procédure de pension alimentaire selon votre situation personnelle.
          </p>
        </div>

        {/* Top 3 cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-8">
          {/* Card 1: Progress */}
          <div className="card bg-white border border-slate-200 shadow-sm p-6 transition-all duration-200 hover:shadow-md">
            <h3 className="font-semibold text-blue-700 mb-3 flex items-center">
              <span className="bg-blue-50 p-2 rounded-full mr-2">📊</span>
              Progression
            </h3>
            <div className="mb-4">
              <div className="flex justify-between text-sm mb-1">
                <span className="font-semibold">{progressPercent}% complété</span>
                <span className="text-slate-500 text-xs">
                  {completedStepsCount} / {totalSteps} étapes
                </span>
              </div>
              <div className="w-full bg-slate-100 rounded-full h-3">
                <div
                  className="bg-blue-500 h-3 rounded-full transition-all duration-500 ease-out"
                  style={{ width: `${progressPercent}%` }}
                ></div>
              </div>
            </div>
          </div>

          {/* Card 2: Documents Count */}
          <div className="card bg-white border border-slate-200 shadow-sm p-6 transition-all duration-200 hover:shadow-md">
            <h3 className="font-semibold text-blue-700 mb-3 flex items-center">
              <span className="bg-blue-50 p-2 rounded-full mr-2">📄</span>
              Documents requis
            </h3>
            <div className="flex items-center justify-center h-16">
              {checklistDocuments.length === 0 ? (
                <p className="text-slate-500 text-center text-sm">
                  Complétez des étapes pour voir les documents requis
                </p>
              ) : (
                <div className="text-center">
                  <p className="text-2xl font-bold text-blue-700">
                    {checklistDocuments.length}
                  </p>
                  <p className="text-sm text-slate-600">documents à préparer</p>
                </div>
              )}
            </div>
          </div>

          {/* Card 3: Actions */}
          <div className="card bg-white border border-slate-200 shadow-sm p-6 transition-all duration-200 hover:shadow-md">
            <h3 className="font-semibold text-blue-700 mb-3 flex items-center">
              <span className="bg-blue-50 p-2 rounded-full mr-2">🔄</span>
              Actions
            </h3>
            <div className="flex justify-center items-center h-16">
              <button
                onClick={resetAll}
                className="btn btn-outline border-red-300 text-red-700 hover:bg-red-50 hover:border-red-400"
              >
                Réinitialiser tout
              </button>
            </div>
          </div>
        </div>

        {/* Documents Checklist */}
        {checklistDocuments.length > 0 && (
          <div className="mb-8">
            <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
              <h2 className="text-xl font-semibold text-blue-700 mb-6 flex items-center">
                <span className="bg-blue-50 p-2 rounded-full mr-2">📋</span>
                Liste des documents à préparer
              </h2>
              
              {/* Documents administratifs */}
              <div className="mb-8">
                <h3 className="font-semibold text-lg mb-4 text-blue-700 flex items-center">
                  <span className="bg-blue-50 p-1 rounded-full mr-2 text-sm">🏛️</span>
                  Documents administratifs
                </h3>
                <div className="grid gap-4 md:grid-cols-2">
                  {checklistDocuments
                    .filter(doc => doc.category === "Documents administratifs")
                    .map((doc) => (
                      <div 
                        key={doc.id}
                        className="bg-white rounded-lg border border-slate-200 p-4 hover:border-blue-200 hover:shadow-md transition-all duration-200"
                      >
                        <h4 className="font-medium text-blue-800 mb-2">{doc.label}</h4>
                        <p className="text-sm text-slate-600">{doc.description}</p>
                      </div>
                    ))}
                </div>
              </div>

              {/* Documents juridiques */}
              <div>
                <h3 className="font-semibold text-lg mb-4 text-blue-700 flex items-center">
                  <span className="bg-blue-50 p-1 rounded-full mr-2 text-sm">⚖️</span>
                  Documents juridiques
                </h3>
                <div className="grid gap-4 md:grid-cols-2">
                  {checklistDocuments
                    .filter(doc => doc.category === "Documents juridiques")
                    .map((doc) => (
                      <div 
                        key={doc.id}
                        className="bg-white rounded-lg border border-slate-200 p-4 hover:border-blue-200 hover:shadow-md transition-all duration-200"
                      >
                        <h4 className="font-medium text-blue-800 mb-2">{doc.label}</h4>
                        <p className="text-sm text-slate-600">{doc.description}</p>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Timeline steps */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
          <div className="p-4 bg-blue-100 text-blue-700">
            <h2 className="text-lg font-bold flex items-center">
              <span className="mr-3 text-2xl">📝</span>
              Questionnaire interactif
            </h2>
            <p className="text-sm mt-1">
              Répondez aux questions pour générer votre liste de documents personnalisée.
            </p>
          </div>

          <div className="p-6">
            <div className="relative">
              <div className="absolute bg-slate-200 w-[3px] h-full left-4 md:left-6 top-0 z-0" />
              <div className="space-y-6">
                {stepsData.map((step, index) => {
                  const isDone = completedSteps.includes(step.id);
                  const isOpen = openStep === step.id;
                  const canOpen = stepsData
                    .slice(0, index)
                    .every((s) => completedSteps.includes(s.id));

                  return (
                    <div key={step.id} className="flex flex-col md:flex-row relative z-10">
                      <div className="mr-6">
                        <div
                          className={`w-8 h-8 rounded-full border-4 ${
                            isDone ? "border-green-500 bg-green-50" : "border-slate-400 bg-white"
                          } flex items-center justify-center text-sm font-bold transition-colors`}
                          style={{ marginLeft: "-2px" }}
                        >
                          {index + 1}
                        </div>
                      </div>
                      <div className="flex-1">
                        <div
                          className={`card border shadow-sm transition-all ${
                            isDone ? "bg-green-50 border-green-200" : "bg-white border-slate-200"
                          } hover:shadow-md`}
                        >
                          <div className="card-body p-6">
                            <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                              <h2
                                className={`card-title text-base ${
                                  isDone ? "text-green-700" : "text-slate-700"
                                }`}
                              >
                                {step.title}
                              </h2>
                            </div>
                            <p className="mt-2 text-sm text-slate-600">{step.shortContent}</p>

                            <div className="mt-3 flex gap-3 flex-wrap">
                              <button
                                className={`btn btn-sm ${
                                  isOpen ? "btn-neutral" : "btn-primary"
                                } ${!canOpen ? "opacity-50 cursor-not-allowed" : ""}`}
                                onClick={() => canOpen && setOpenStep(isOpen ? null : step.id)}
                                disabled={!canOpen}
                              >
                                {isOpen ? "Masquer détails" : "Voir détails"}
                              </button>
                              {!isDone && (
                                <button
                                  className="btn btn-sm btn-success hover:bg-green-600 transition-colors"
                                  onClick={() => markStepAsDone(step)}
                                >
                                  Terminer l'étape
                                </button>
                              )}
                              {isDone && (
                                <span className="text-green-700 font-semibold self-center ml-2 text-sm flex items-center">
                                  <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                  </svg>
                                  Terminée
                                </span>
                              )}
                            </div>

                            {/* Questions panel */}
                            {isOpen && (
                              <div className="mt-4 p-4 border rounded-lg bg-slate-50 space-y-4">
                                <div
                                  className="text-sm text-slate-600"
                                  dangerouslySetInnerHTML={{ __html: step.detailedContent }}
                                />

                                {step.questions?.length > 0 && (
                                  <div className="space-y-6 mt-4">
                                    {step.questions.map((q) => {
                                      if (q.showIf && !q.showIf(answers)) return null;

                                      const stepAns = answers[step.id] || {};
                                      const selectedValue = stepAns[q.id] || "";

                                      if (q.options) {
                                        return (
                                          <div key={q.id} className="space-y-2">
                                            <label className="font-medium text-slate-700 block">
                                              {q.label}
                                            </label>
                                            {q.help && (
                                              <p className="text-xs text-slate-500">{q.help}</p>
                                            )}
                                            <div className="ml-4 space-y-2">
                                              {q.options.map((opt) => (
                                                <label
                                                  key={opt.value}
                                                  className="cursor-pointer flex items-center gap-2 hover:bg-slate-100 p-2 rounded-md transition-colors"
                                                >
                                                  <input
                                                    type="radio"
                                                    className="radio radio-primary"
                                                    name={`${step.id}-${q.id}`}
                                                    value={opt.value}
                                                    checked={selectedValue === opt.value}
                                                    onChange={() =>
                                                      handleAnswerChange(step.id, q.id, opt.value)
                                                    }
                                                  />
                                                  <span className="text-slate-700">{opt.label}</span>
                                                </label>
                                              ))}
                                            </div>
                                          </div>
                                        );
                                      }
                                      return null;
                                    })}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Legal note */}
        <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 text-sm text-slate-600 mt-8">
          <p className="italic text-center">
            Note : Cette checklist est fournie à titre informatif. Pour des conseils juridiques adaptés 
            à votre situation, consultez un professionnel du droit.
          </p>
        </div>
      </main>
    </div>
  );
}
